import styled, { css } from 'styled-components';

export const Ringil3H3 = styled.div`
  color: #000;
  font-size: 1rem;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Ringil3BadgeRow = styled.div`
  flex-direction: row;
  display: flex;
  column-gap: 0.5rem;
  align-items: flex-start;
  flex-wrap: wrap;

  > * {
    margin-bottom: 0.5rem;
  }
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: var(--ringil3-base-color);
  margin: 0.5rem 0;
  padding: 2rem 1rem;
  gap: 0.5rem;
`;

export const Paragraph = styled.p`
  font-size: 15px;
  color: var(--ringil3-gr4);
`;

export const Card = styled.div`
  border-radius: 0.5rem;
  background-color: white;
  padding: 1.5rem 1rem;
  width: 100%;
`;

export const GrayText = styled.div`
  color: var(--ringil3-gr4);
`;

export const LargeText = styled.div`
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #000000;
`;

export const HorizontalLine = styled.hr<{ variant: 'brand-light' | 'normal' | 'tertiary' | 'quaternary' }>`
  width: 100%;
  margin: 0rem 0;
  border: 0px;
  ${props =>
    props.variant === 'normal' &&
    css`
      border-bottom: 1px solid var(--ringil3-gr4);
    `}
  ${props =>
    props.variant === 'brand-light' &&
    css`
      border-bottom: 1px solid var(--ringil3-brand-light-color);
    `}
  ${props =>
    props.variant === 'tertiary' &&
    css`
      border-bottom: 1px solid var(--ringil3-content-tertiary-color);
    `}
  ${props =>
    props.variant === 'quaternary' &&
    css`
      border-bottom: 1px solid var(--ringil3-content-quaternary);
    `};
`;

export const ClickableCursor = styled.div`
  display: inline-block;
  cursor: pointer;
`;

/** Inline clickable text. Hover matches RingilButton's link mode (see clickableText.ts). */
export const Clickable = styled.div`
  display: inline-block;
  cursor: pointer;
  color: var(--ringil3-brand-color);
  transition: all 0.2s;

  &:hover {
    color: var(--ringil3-complementary-brand-dark, #e54800);
  }
`;

export const Ringil3Note = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--ringil3-gr4);
`;

export const InputAndButtonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
`;

/**
 * Used for new pages - should be refactored
 */
export const Test = styled.div`
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  color: black;
  gap: 1rem;

  .p-checkbox .p-checkbox-box.p-highlight {
    border-color: var(--ringil3-brand-color);
    background: var(--ringil3-brand-color);
  }
`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 1rem;
  width: 100%;
`;

export const OrderWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 1rem;

  /* Anchors the scroll target above. */
  position: relative;

  margin: 0 -1rem;
  padding: 1rem;

  /* The surrounding card already provides the outer spacing — the negative margin cancels it
     horizontally, and this keeps the first order from sitting 40px down from the card's edge.
     Padding between consecutive orders is still wanted. */
  &:first-child {
    padding-top: 0;
  }
`;

export const ColOdd = styled.div`
  display: flex;
  flex-direction: column;

  ${OrderWrapper}:nth-child(odd) {
    background-color: var(--base-basequaternary);
  }
`;

export const ColEven = styled.div`
  display: flex;
  flex-direction: column;

  ${OrderWrapper}:nth-child(even) {
    background-color: var(--base-basequaternary);
  }
`;

export const TwoColGridWithoutGap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ThreeColGridWithoutGap = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr;
`;

/**
 * Invisible scroll target sitting above its order.
 *
 * Absolutely positioned so it stays out of the flow: as a flex child of {@link OrderWrapper} it
 * would otherwise claim a `gap` of its own and push the order's heading down, even at zero height.
 */
export const Anchor = styled.div`
  display: block;
  position: absolute;
  top: -70px;
  visibility: hidden;
`;
